import NewProperty from './NewProperty';

export default NewProperty;
